import {lazy} from 'react'
import * as B from '../block'
import {meta} from './meta'

const Admin = lazy(() => import('./admin').then(m => ({default: m.Admin})))

const InnerBlock = lazy(() =>
  import('./SubnavBlock').then(m => ({default: m.SubnavBlock})),
)

export const subnavBlockInfo = B.blockInfo({
  ...meta,
  Admin,
  InnerBlock,
  dividers: false,
})
